import { Component, OnInit, Input } from '@angular/core';
import { MyRemaxModes, ListingCategory } from '../../../classes/enums';
import { UserService } from '../../../services/user.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { User } from '../../../classes/user';
import { LoginService } from '../../../services/login.service';
import { Router } from '@angular/router';
import { PreferencesService } from '../../../services/preferences.service';

@Component({
  selector: 'app-my-remax-menu',
  templateUrl: './my-remax-menu.component.html',
  styleUrls: ['./my-remax-menu.component.scss']
})
export class MyRemaxMenuComponent extends HasSubscriptions implements OnInit {
  @Input() listingCategory: ListingCategory;
  currentUser: User;
  ListingCategory = ListingCategory;
  favouriteAgentUrl: string;
  constructor(private userService: UserService,
    private loginService: LoginService,
    private router: Router,
    private preferencesService: PreferencesService) {
    super();
  }

  ngOnInit() {
    this.addSub(this.userService.currentUser.subscribe((currentUser) => this.currentUser = currentUser));
    this.addSub(this.preferencesService.favouriteAgentUrlChanged.subscribe((url) => this.favouriteAgentUrl = url));
  }

  logout() {
    this.loginService.logout().toPromise().then(() => {
      const queryIndex = this.router.url.indexOf('?');
      const url = queryIndex === -1 ? this.router.url : this.router.url.substring(0, queryIndex);
      this.router.navigate([url]);
    });
  }

  MyRemaxModes = MyRemaxModes;
}
